module.exports = __webpack_public_path__ + "img/grid.b2599070.svg";